import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { BehaviorSubject, interval, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import { SocketService } from './socket.service';
import { LivestreamStatus } from '../models/livestream-status.socket';

@Injectable({
    providedIn: 'root'
})
export class LiveService {

    private readonly disconnect$ = new Subject<void>();

    private _status$ = new BehaviorSubject<LivestreamStatus>({ isLive: false, streams: null, nextStream: null });
    get status$(): Observable<LivestreamStatus> {
        return this._status$.asObservable();
    }

    private readonly statusIntervalMinutes = 10;

    constructor(
        private envService: EnvironmentService,
        private http: HttpClient,
        private socket: SocketService) {

        this.socket.connected$.subscribe(connected => {
            if (connected) {
                this.init();
            } else {
                this.disconnect();
            }
        });
    }

    init() {
        this.socket.onMessage('livestream').pipe(takeUntil(this.disconnect$)).subscribe(data => {
            const parsed = JSON.parse(data);

            switch (parsed.type) {
                case 'status':
                    this.handleStatus(parsed.body);
                    break;
                case 'status-updated':
                    this.requestStatus();
                    break;
            }
        });
        this.requestStatus()
        interval(this.statusIntervalMinutes * 60 * 1000).pipe(takeUntil(this.disconnect$)).subscribe(() => this.requestStatus())
    }

    disconnect() {
        this.disconnect$.next();
    }

    handleStatus(message: LivestreamStatus) {
        this._status$.next(message);
    }

    requestStatus() {
        this.socket.sendMessage('livestream', { type: 'status' });
    }

    getLiveMediaV2() {
        return this.http.get<any>(this.envService.contentHost + '/v2/live/media')
    }

    reportWatchtime(guid: string, livestreamId: number, watchDurationMs: number = undefined) {
        let params = new HttpParams()
            .set('livestreamId', livestreamId.toString());

        if (watchDurationMs !== undefined) {
            params = params.set('watchDurationMs', watchDurationMs.toString());
        }

        return this.http.post(`${this.envService.contentHost}/v2/live/${guid}`, {}, { params });
    }
}
